import React from "react"
import { CopyToClipboard } from "react-copy-to-clipboard"
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined"
import styled from "styled-components/macro"
import * as IconsGallery from "@iconsGallery"
import {
  CardContent as MuiCardContent,
  Typography as MuiTypography,
  Button,
  Grid,
  IconButton,
  Tooltip,
} from "@material-ui/core"
export const StyledMainWrapperCardViewVideo = styled(Grid)`
  min-width: 400px;
  max-width: 744px;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 18px;
  margin: 10px;
  width: 100%;
`
export const StyledItemWrapperCardViewVideo = styled(Grid)`
  width: 100%;
  min-height: 150px;
  height: fit-content;
  border-radius: 15px;
  border: 1px solid #e8dff2;
  padding: 10px;
  transition: all 400ms ease;

  .cls-header-kit-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 38px;
    position: relative;
  }

  .cls-header-kit-container-title {
    min-width: 100px;
    width: 70%;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    font-weight: bold;
    margin-left: 10px;
  }
  .cls-header-kit-container-video-thumb {
    width: 100%;
    padding: 1px;
    margin-top: 10px;
    svg {
      width: 100%;
      height: fit-content;
    }
  }
`

const defaultData = [
  {
    title: "test",
    url: "test",
  },
  {
    title: "test2",
    url: "test2",
  },
  {
    title: "test3",
    url: "test3",
  },
  {
    title: "test4",
    url: "test4",
  },
  {
    title: "test5",
    url: "test5",
  },
  {
    title: "test6",
    url: "test6",
  },
  {
    title: "test7",
    url: "test7",
  },
  {
    title: "test8",
    url: "test8",
  },
]

const VideoBoard = (innerItem) => {
  const [getCopyText, setCopyText] = React.useState("")
  const [getCopyTextFlag, setCopyTextFlag] = React.useState(false)

  return (
    <StyledItemWrapperCardViewVideo style={{ cursor: "pointer" }}>
      <div className="cls-header-kit-container">
        <div className="cls-header-kit-container-title">
          {`${innerItem?.globalType} ${innerItem?.title}`}
        </div>
      </div>
      <div className="cls-header-kit-container-video-thumb">
        <video width="720" height="405" controls>
          <source src={innerItem?.url} type="video/mp4" />
        </video>
      </div>
    </StyledItemWrapperCardViewVideo>
  )
}
function MultipleVideoPlayer(props) {
  const { globalType = "Verkada", list = defaultData || [] } = props || {}

  return (
    <StyledMainWrapperCardViewVideo>
      {list.length ? (
        list.map((itm) => {
          return <VideoBoard {...itm} globalType={globalType} />
        })
      ) : (
        <div>{`No Records Found`}</div>
      )}
    </StyledMainWrapperCardViewVideo>
  )
}

export { MultipleVideoPlayer }
export default MultipleVideoPlayer
